module.exports = __webpack_public_path__ + "static/media/volumeOff.251a8f4f.svg";